import { IconButton } from 'src/components/atoms';
import {
  ProgressBar,
  ProgressBarFiller,
} from 'src/components/atoms/ProgressBar/ProgressBar.styles';
import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const AudioButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
`;

export const StyledText = styled.p<{ lighterColor?: boolean }>`
  margin: 0;
  min-width: 40px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) =>
    props.lighterColor
      ? props.theme.atlas.semantic.color.type.muted
      : props.theme.atlas.semantic.color.type.default};
`;

export const AudioControls = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-self: flex-start;
  gap: 20px;
  /** Mozilla Firefox */
  @-moz-document url-prefix() {
    margin-top: 15px;
  }
`;

export const StyledIconButton = styled(IconButton)`
  border: none;
  color: white;
  padding: 20px;
  width: 40px;
  height: 40px;
`;

export const TimeContainer = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const AudioProgressBar = styled(ProgressBar)`
  margin-right: 0;
  position: relative;
  cursor: pointer;
`;

export const AudioProgressBarSeeker = styled.div<{
  percentage?: number;
  animated: boolean;
}>`
  left: ${(props) => props.percentage}%;
  ${(props) => (props.animated ? 'transition: left 0.25s linear;' : '')}
  top: -5px;
  transform: translateX(-50%);
  height: 18px;
  width: 18px;
  border-radius: 50%;
  position: absolute;
  background: ${(props) => props.theme.atlas.semantic.color.type.default};
  pointer-events: none;
`;
export const AudioProgressBarFiller = styled(ProgressBarFiller)<{
  animated: boolean;
}>`
  ${(props) => (props.animated ? 'transition: width 0.25s linear;' : '')}
  background: ${(props) => props.theme.atlas.semantic.color.type.default};
`;
